__turbopack_context__.v({
  "button": "_8T9JkW_button",
  "confirmPassword": "_8T9JkW_confirmPassword",
  "container": "_8T9JkW_container",
  "description": "_8T9JkW_description",
  "form": "_8T9JkW_form",
  "logo": "_8T9JkW_logo",
  "password": "_8T9JkW_password",
  "title": "_8T9JkW_title",
});
